import axios from "axios"
import React, { Component } from "react"
import { Button, Modal, OverlayTrigger, ProgressBar, Spinner, Tooltip } from "react-bootstrap"
import AxiosConfig from "../../../../../../../../utilities/AxiosConfig"
import reggie from "../../../../../../../../utilities/Reggie"
import snackBar from "../../../../../../../../utilities/snackBar/SnackBar"
import ChecklistTypes from "../../../../../../Types/ChecklistTypes"
import WorkCompReferenceTypes from "../../../../../../Types/WorkCompReferenceTypes"
import IncidentChecklistConfig from "./IncidentChecklistConfig/IncidentChecklistConfig"
import "./IncidentChecklist.css"

interface Props {
    WorkersCompensationIncidentId: number
    contextUserId: string | number
    IncidentTypeId: number
    workCompReference: WorkCompReferenceTypes
    readOnly: boolean
}

interface State {
    checklist: Array<ChecklistTypes> | []
    confirm: boolean
    loading: boolean
    config: boolean
}

class IncidentChecklist extends Component<Props, State>{

    checklistCopy: Array<ChecklistTypes> = []
    index = 0
    state = {
        checklist: [],
        confirm: false,
        loading: true,
        config: false
    }

    componentDidMount() {
        this.getIncidentChecklist()
        // this.getIncidentBaseChecklist()
    }

    getIncidentChecklist = () => {
        this.setState({ loading: true })
        let WorkersCompensationIncidentId = this.props.WorkersCompensationIncidentId
        if (WorkersCompensationIncidentId) {
            axios.get(process.env.REACT_APP_API_URL + `/api/workComp/getIncidentChecklist/${WorkersCompensationIncidentId}`, AxiosConfig.configValue("min"))
                .then((res) => {
                    // //console.log("getIncidentChecklist:", res.data)
                    this.setState({ checklist: res.data, loading: false })
                    this.checklistCopy = JSON.parse(JSON.stringify(res.data))
                })
                .catch((err) => {
                    this.setState({ loading: false })
                    snackBar({ text: "Failed to fetch Incident checklist", type: "error", timeout: 4000 })
                })
        } else {
            setTimeout(() => {
                this.getIncidentChecklist()//for some reason WorkersCompensationIncidentId is null on mount 
            }, 500)
        }
    }

    updateChecklist = (item: ChecklistTypes) => {
        this.setState({ loading: true })
        axios.post(process.env.REACT_APP_API_URL + "/api/workComp/addOrUpdateIncidentChecklistPost", item, AxiosConfig.configValue("min"))
            .then((res) => {
                // //console.log("updateChecklist:", res.data)
                this.getIncidentChecklist()
                snackBar({ text: "Updated Incident checklist", type: "success", timeout: 4000 })
            })
            .catch(() => {
                this.setState({ loading: false })
                snackBar({ text: "Failed to update Incident checklist", type: "error", timeout: 4000 })
            })
    }

    progress = () => {
        let sum = 0
        let checklist = this.state.checklist
        for (let i = 0; i < checklist.length; i++) {
            //@ts-ignore
            if (checklist[i].Checked) {
                sum++
            }
        }
        return { sum: `${sum}/${checklist.length}`, percent: (sum / checklist.length) * 100 }
    }

    calculateVariant = (progress: number) => {
        if (progress < 100) {
            return "warning"
        }
        return "primary"
    }

    modalHeaderText = () => {
        let item = this.state.checklist[this.index]
        //@ts-ignore
        if (item.Checked) {
            return (
                <div className="ConfirmIncidentCheckedModalHeader">
                    <p>Mark this item as complete?</p>
                </div>
            )
        }
        return (
            <div className="ConfirmIncidentCheckedModalHeader">
                <p>Mark this item as incomplete?</p>
            </div>
        )
    }

    modalBodyText = () => {
        let item = this.state.checklist[this.index]
        //@ts-ignore
        let text = item.ChecklistText
        //@ts-ignore
        if (item.Checked) {
            return (
                <div className="ConfirmIncidentCheckedModalBodyComplete">
                    <p>{text}</p>
                </div>
            )
        }
        return (
            <div className="ConfirmIncidentCheckedModalBodyIncomplete">
                <p>{text}</p>
            </div>
        )
    }

    getIncidentType = () => {
        let incidentTypes = this.props.workCompReference.incidentTypes
        for (let i = 0; i < incidentTypes.length; i++) {
            if (incidentTypes[i].id === this.props.IncidentTypeId) {
                return incidentTypes[i]
            }
        }
        return null
    }

    toggleChecked = (index: number) => {
        this.index = index
        let temp = this.state.checklist
        //@ts-ignore
        let toggle = temp[index].Checked
        //@ts-ignore
        temp[index].Checked = !toggle
        this.setState({ checklist: temp, confirm: !this.state.confirm })
    }

    toggle = (key: string) => {
        let temp: any = this.state
        temp[key] = !temp[key]
        this.setState(temp)
    }

    save = (shouldSave: boolean) => {
        if (shouldSave) {
            this.updateChecklist(this.state.checklist[this.index])
        } else {
            this.toggleChecked(this.index)
        }
        this.setState({ confirm: !this.state.confirm })
    }

    render() {

        const props = this.props
        let checklist = this.state.checklist
        let progress = this.progress()
        let variant = this.calculateVariant(progress.percent)
        let loading = this.state.loading
        let checklistTitle = this.getIncidentType()?.text || "Incident checklist"
        let pillType = "Raised"
        const readOnly = props.readOnly

        const toolTip = (text: string) => (
            <Tooltip id="uac-tool-tip">
                {text || "No description availale"}
            </Tooltip>
        )

        // //console.log(checklist)

        return (
            <div className="IncidentChecklist">
                <div className="IncidentChecklistHeader">
                    <div className={`IncidentChecklistHeaderLeft${pillType}`}>
                        {progress.percent === 100 && <span className="material-icons">done</span>}
                        <p>{checklistTitle} checklist</p>
                    </div>
                    {!loading && !readOnly && <div className="IncidentChecklistHeaderRight">
                        <span id="vehicle-incident-checklist-gear-btn" className="material-icons" onClick={() => this.toggle("config")}>settings</span>
                        {/* <span id="vehicle-incident-checklist-info-btn" className="material-icons">info</span> */}
                    </div>}
                    {loading && <div className="IncidentChecklistHeaderRight">
                        <Spinner id="incident-checklist-load-spinner" animation="border" />
                    </div>}
                </div>
                <div className="IncidentChecklistBody">
                    {checklist.map((item: ChecklistTypes, index: number) =>
                        <div className="IncidentChecklistBodyListItem" key={item.IncidentChecklistId}>
                            <div className="IncidentChecklistItem">
                                <input disabled={readOnly} onChange={() => this.toggleChecked(index)} checked={item.Checked} type="checkbox"></input>
                                {item.ChecklistText.length >= 20 && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.ChecklistText)}>
                                    <p>{item.ChecklistText}</p>
                                </OverlayTrigger>}
                                {item.ChecklistText.length < 20 && <p>{item.ChecklistText}</p>}
                            </div>
                            <div className="IncidentChecklistItemDescription">
                                {item.InfoText && item.InfoText !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.InfoText)}>
                                    <span className="material-icons">info</span>
                                </OverlayTrigger>}
                                {item.DocumentLink && item.DocumentLink !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.DocumentLink)}>
                                    <a href={item.DocumentLink || ""} target="_blank" rel="noreferrer"><span className="material-icons">description</span></a>
                                </OverlayTrigger>}
                                {item.Email && item.Email !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.Email)}>
                                    <a href={`mailto:${item.Email || ""}`} target="_blank" rel="noreferrer"><span className="material-icons">mail</span></a>
                                </OverlayTrigger>}
                                {item.Phone && item.Phone !== "" && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="top" overlay={toolTip(item.Phone)}>
                                    <a href={`tel:${reggie.formatPhone(item.Phone || "")}`}><span className="material-icons">call</span></a>
                                </OverlayTrigger>}
                            </div>
                        </div>)}
                </div>
                <div className="IncidentChecklistFooter">
                    <p>{progress.sum} Completed</p>
                    <ProgressBar id={`vehicle-incident-checklist-progress-bar-${variant}`} now={progress.percent} />
                </div>
                {this.state.confirm && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="ConfirmIncidentCheckedModalHeader">
                            {this.modalHeaderText()}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ConfirmIncidentCheckedModalBody">
                            {this.modalBodyText()}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="ConfirmIncidentCheckedModalFooter">
                            <Button variant="secondary" onClick={() => this.save(false)}>Cancel</Button>
                            <Button variant="primary" onClick={() => this.save(true)}>Yes</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.config &&
                    <IncidentChecklistConfig
                        toggleConfig={this.toggle}
                        IncidentTypeId={this.props.IncidentTypeId}
                        workCompReference={this.props.workCompReference}
                        checklist={checklist}
                        updateChecklist={this.updateChecklist}
                        contextUserId={this.props.contextUserId}
                        IncidentId={this.props.WorkersCompensationIncidentId}
                        loading={this.state.loading}
                        getIncidentType={this.getIncidentType}
                    />}
            </div>
        )
    }
}

export default IncidentChecklist